import React, { Component } from 'react';
import Ionicon from "react-ionicons";

class DeleteModal extends Component {

    renderMessage(header, message, onClose, onDelete) {
        return (
            <div>
                <h3 className="h3">{header}</h3>
                <p className="p-tag">{message}</p>
                <ul className="buttons-right">
                    <li>
                        <button className="theme-button white" onClick={(e) => onClose(e)} >
                            Cancel
                        </button>
                    </li>
                    <li>
                        <button className="theme-button" onClick={() => onDelete()}>
                            Confirm
                        </button>
                    </li>
                </ul>
            </div>
        )
    }

    render() {

        const { isOpen, onClose, header, message, onDelete } = this.props;

        if (isOpen === false)
            return null;

        return (
            <div className="popup-default">
                <div className="popup-inner">
                    <div className="popup-content">
                        <button className="close-popup" type="button" onClick={(e) => onClose(e)}><Ionicon
                            icon="ion-close" /></button>
                        {this.renderMessage(header, message, onClose, onDelete)}
                    </div>
                </div>
            </div>
        )
    }
}

export default DeleteModal


// WEBPACK FOOTER //
// src/client/components/common/elements/DeleteModal.js